
import apiClient from '../helpers/apiClient';
import { authHeader } from '../helpers/authHeader';


export const bankingService = {
    bankingList,
    bankingDetails,
    submitBanking,
    bankListByDate,
    transferToAnotherAccount,
    receiveFromAnotherAccount,
    deleteReceiveFromAnotherAccount,
    deleteReceiveToAnotherAccount,
    bankingTransferDetails,
    fundTransferList

};

async function  bankingList() {
    return apiClient.get(`/banking/banking-list`, authHeader());
}



async function  bankListByDate(body) {
    return apiClient.put(`/banking/bank-list-by-date`, body, authHeader());
}




async function  bankingDetails(salesOrderId) {
    return apiClient.get(`/banking/banking-details/${salesOrderId}`, authHeader());
}

async function  bankingTransferDetails(id) {
    return apiClient.get(`/banking/banking-transfer-details/${id}`, authHeader());
}


async function  submitBanking(formData) {
    return apiClient.post(`/banking/submit-banking`,formData, authHeader());
}


async function  fundTransferList() {
    return apiClient.get(`/banking/fund-transfer-list`, authHeader());
}


async function  transferToAnotherAccount(formData) {
    return apiClient.post(`/banking/fund-transfer-transfer-to-another-account`,formData, authHeader());
}


async function  receiveFromAnotherAccount(formData) {
    return apiClient.post(`/banking/fund-transfer-receive-from-another-account`,formData, authHeader());
}




async function  deleteReceiveFromAnotherAccount(id) {
    return apiClient.delete(`/banking/delete-receive-from-another-account/${id}`,authHeader());
}


async function  deleteReceiveToAnotherAccount(id) {
    return apiClient.delete(`/banking/delete-receive-to-another-account/${id}`,authHeader());
}



















